import { ReactNode } from "react";
import { MoreHorizontal } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/atoms/ui/dropdown-menu";
import { Button } from "@/components/atoms/ui/button";

import DropdownActionItem from "./DropdownActionItem";

export type ActionItemProps = {
  label: string;
  icon?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  noSeparator?: boolean;
};

type DropdownActionProps = {
  children: ReactNode;
  triggerComponent?: ReactNode;
};

const DropdownAction = ({ children, triggerComponent }: DropdownActionProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {triggerComponent ? (
          triggerComponent
        ) : (
          <Button className="h-8 w-8 p-0" variant="ghost">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        )}
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">{children}</DropdownMenuContent>
    </DropdownMenu>
  );
};

DropdownAction.Item = DropdownActionItem;
DropdownAction.Separator = DropdownMenuSeparator;

export default DropdownAction;
